// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QuestionOutlinedSvg from "@ant-design/icons-svg/es/asn/QuestionOutlined";
import AntdIcon from '../components/AntdIcon';

var QuestionOutlined = function QuestionOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: QuestionOutlinedSvg
  }));
};

QuestionOutlined.displayName = 'QuestionOutlined';
export default React.forwardRef(QuestionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/QuestionOutlined.js
// module id = 1659
// module chunks = 0